<!-- CartAddedModal.vue (Bootstrap 5.3 적용판) -->
<template>
  <div
    ref="modalEl"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="cartAddedLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <slot name="header">
            <h5 id="cartAddedLabel" class="modal-title">장바구니 담기</h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="close"
            ></button>
          </slot>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <slot name="body">
            <p class="mb-0">장바구니에 상품이 정상적으로 담겼습니다.</p>
          </slot>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="close"
            >
              쇼핑 계속하기
            </button>
            <button type="button" class="btn btn-primary" @click="goCart">
              장바구니로 이동
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * Bootstrap 5.3 Modal (opt-in)
 * - 번들 하나만 사용: bootstrap.bundle.min.js 또는 ESM 부분 임포트
 * - window.bootstrap 사용하지 않음
 */
import { ref, onMounted, onBeforeUnmount, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";

const emit = defineEmits(["close"]);
const router = useRouter();

const modalEl = ref(null);
let modalInst = null;

onMounted(() => {
  modalInst = Modal.getOrCreateInstance(modalEl.value, {
    backdrop: true,
    keyboard: true,
    focus: true,
  });
  modalEl.value.addEventListener("hidden.bs.modal", () => emit("close"));
  modalInst.show();
});

onBeforeUnmount(() => {
  modalInst?.dispose();
});

function close() {
  modalInst?.hide();
}

function goCart() {
  close();
  router.push({ path: "/cartview" });
}
</script>

<!-- Bootstrap 유틸리티로 충분 — 별도 CSS 불필요 -->
<style scoped></style>
